import { useState } from 'react'

function FormularioCuenta({ onCuentaCreada, userId }) {
  const [nombre, setNombre] = useState('')
  const [categoria, setCategoria] = useState('other')
  const [usuarioHint, setUsuarioHint] = useState('')
  const [instruccion, setInstruccion] = useState('')
  const [accion, setAccion] = useState('transfer')
  const [esCritica, setEsCritica] = useState(false)
  const [enviando, setEnviando] = useState(false)
  const [error, setError] = useState('')

  async function handleSubmit(e) {
    e.preventDefault()
    setEnviando(true)
    setError('')

    try {
      const respuesta = await fetch('https://legado-digital-production.up.railway.app/api/accounts', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          userId,
          nombre,
          categoria,
          usuarioHint,
          instruccionHeredero: instruccion,
          accionPostMuerte: accion,
          esCritica,
        }),
      })

      const datos = await respuesta.json()

      if (!datos.ok) {
        setError(datos.error || 'Error al crear la cuenta')
        return
      }

      setNombre('')
      setCategoria('other')
      setUsuarioHint('')
      setInstruccion('')
      setAccion('transfer')
      setEsCritica(false)
      onCuentaCreada(datos.datos)

    } catch {
      setError('No se pudo conectar con el servidor')
    } finally {
      setEnviando(false)
    }
  }

  return (
    <form onSubmit={handleSubmit} style={estilos.formulario}>
      <h3 style={estilos.titulo}>Añadir cuenta digital</h3>

      {error && <div style={estilos.error}>{error}</div>}

      <div style={estilos.grid}>
        <div style={estilos.campo}>
          <label style={estilos.label}>Nombre del servicio</label>
          <input
            type="text"
            placeholder="Ej: Gmail personal, BBVA..."
            value={nombre}
            onChange={e => setNombre(e.target.value)}
            style={estilos.input}
            required
          />
        </div>

        <div style={estilos.campo}>
          <label style={estilos.label}>Categoría</label>
          <select
            value={categoria}
            onChange={e => setCategoria(e.target.value)}
            style={estilos.input}
          >
            <option value="email">Email</option>
            <option value="social">Red social</option>
            <option value="banking">Banco</option>
            <option value="streaming">Streaming</option>
            <option value="cloud_storage">Almacenamiento</option>
            <option value="work">Trabajo</option>
            <option value="shopping">Compras</option>
            <option value="gaming">Gaming</option>
            <option value="other">Otro</option>
          </select>
        </div>
      </div>

      <div style={estilos.campo}>
        <label style={estilos.label}>Pista del usuario (sin contraseña)</label>
        <input
          type="text"
          placeholder="Ej: empieza por 'meli...'"
          value={usuarioHint}
          onChange={e => setUsuarioHint(e.target.value)}
          style={estilos.input}
        />
      </div>

      <div style={estilos.campo}>
        <label style={estilos.label}>Qué hacer cuando fallezca</label>
        <select
          value={accion}
          onChange={e => setAccion(e.target.value)}
          style={estilos.input}
        >
          <option value="transfer">Transferir acceso a mi círculo</option>
          <option value="delete">Eliminar cuenta</option>
          <option value="memorialize">Mantener activa</option>
          <option value="notify_only">Solo notificar</option>
        </select>
      </div>

      <div style={estilos.campo}>
        <label style={estilos.label}>Instrucciones para tu círculo</label>
        <input
          type="text"
          placeholder="Ej: Descargar fotos antes de eliminar"
          value={instruccion}
          onChange={e => setInstruccion(e.target.value)}
          style={estilos.input}
        />
      </div>

      <div style={estilos.checkboxFila}>
        <input
          type="checkbox"
          id="critica"
          checked={esCritica}
          onChange={e => setEsCritica(e.target.checked)}
        />
        <label htmlFor="critica" style={estilos.checkboxLabel}>
          Cuenta importante — aparece primero en la lista
        </label>
      </div>

      <button
        type="submit"
        disabled={enviando}
        style={{ ...estilos.boton, opacity: enviando ? 0.7 : 1 }}
      >
        {enviando ? 'Guardando...' : 'Añadir cuenta'}
      </button>
    </form>
  )
}

const estilos = {
  formulario: {
    backgroundColor: '#ffffff',
    borderRadius: '8px',
    padding: '20px',
    border: '1px solid #e0e0e0',
    marginBottom: '24px',
  },
  titulo: {
    fontSize: '16px',
    fontWeight: '600',
    marginBottom: '16px',
    color: '#1a1a2e',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '12px',
  },
  campo: { marginBottom: '14px' },
  label: {
    display: 'block',
    fontSize: '13px',
    fontWeight: '500',
    color: '#555',
    marginBottom: '6px',
  },
  input: {
    width: '100%',
    padding: '10px 12px',
    borderRadius: '6px',
    border: '1px solid #ddd',
    fontSize: '14px',
    outline: 'none',
    backgroundColor: '#fff',
  },
  checkboxFila: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginBottom: '16px',
  },
  checkboxLabel: {
    fontSize: '13px',
    color: '#555',
  },
  boton: {
    width: '100%',
    padding: '11px',
    backgroundColor: '#1a1a2e',
    color: '#ffffff',
    border: 'none',
    borderRadius: '6px',
    fontSize: '14px',
    fontWeight: '500',
    cursor: 'pointer',
  },
  error: {
    backgroundColor: '#f8d7da',
    color: '#721c24',
    padding: '10px 12px',
    borderRadius: '6px',
    fontSize: '13px',
    marginBottom: '14px',
  },
}

export default FormularioCuenta